(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["flaire-celestial-footer"] && !Shopify.designMode) return;
  try {
    
  const initializeFlaireCelestial = (root) => {
    const sections = root.matches && root.matches('[data-flaire-celestial]')
      ? [root]
      : root.querySelectorAll('[data-flaire-celestial]');

    sections.forEach((section) => {
      if (section.dataset.flaireReady === 'true') return;
      section.dataset.flaireReady = 'true';

      const stage = section.querySelector('.flaire-celestial__stage');
      const canvas = section.querySelector('[data-flaire-canvas]');
      const context = canvas ? canvas.getContext('2d') : null;
      const core = section.querySelector('[data-flaire-core]');
      const status = section.querySelector('[data-flaire-status]');
      const links = Array.from(section.querySelectorAll('[data-flaire-destination]'));
      const nodes = Array.from(section.querySelectorAll('[data-flaire-node]'));
      const motionToggle = section.querySelector('[data-flaire-motion-toggle]');
      const motionLabel = section.querySelector('[data-flaire-motion-label]');
      const initialStatus = status ? status.textContent : '';
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const motionEnabled = section.classList.contains('flaire-celestial--motion') && !reducedMotion;
      const orbitDuration = Math.max(36, Number(section.dataset.orbitDuration) || 62);
      const activeMotionLabel = section.dataset.motionActiveLabel || '';
      const pausedMotionLabel = section.dataset.motionPausedLabel || '';
      const tau = Math.PI * 2;
      const stars = Array.from({ length: 92 }, () => ({
        x: Math.random(),
        y: Math.random(),
        size: 0.35 + Math.random() * 1.45,
        phase: Math.random() * tau,
        pulse: 0.45 + Math.random() * 1.45,
        drift: (Math.random() - 0.5) * 0.000012
      }));

      let orbitAngle = 0;
      let previousTime = performance.now();
      let userPaused = !motionEnabled;
      let interactionPaused = false;
      let activeIndex = -1;
      let visible = true;
      let frameId;
      let canvasWidth = 1;
      let canvasHeight = 1;
      let canvasOffsetX = 0;
      let canvasOffsetY = 0;
      let stageWidth = 1;
      let stageHeight = 1;
      let radiusX = 1;
      let radiusY = 1;
      let desktopOrbit = false;
      let nodeCoordinates = [];
      let pointerX = 0;
      let pointerY = 0;
      let pointerTargetX = 0;
      let pointerTargetY = 0;

      const measure = () => {
        if (!stage) return;
        const stageBounds = stage.getBoundingClientRect();
        const canvasBounds = canvas ? canvas.getBoundingClientRect() : stageBounds;
        const firstNodeBounds = nodes[0] ? nodes[0].getBoundingClientRect() : { width: 220 };
        stageWidth = Math.max(1, stageBounds.width);
        stageHeight = Math.max(1, stageBounds.height);
        canvasWidth = Math.max(1, canvasBounds.width);
        canvasHeight = Math.max(1, canvasBounds.height);
        canvasOffsetX = stageBounds.left - canvasBounds.left;
        canvasOffsetY = stageBounds.top - canvasBounds.top;
        desktopOrbit = window.matchMedia('(min-width: 990px)').matches;
        if (desktopOrbit) {
          radiusX = Math.max(285, Math.min(555, (stageWidth - firstNodeBounds.width) / 2 - 22));
          radiusY = Math.max(248, Math.min(310, stageHeight * 0.39));
        } else {
          radiusX = Math.max(92, Math.min(285, (stageWidth - firstNodeBounds.width) / 2 - 6));
          radiusY = Math.max(230, Math.min(285, stageHeight * 0.39));
        }

        if (canvas && context) {
          const pixelRatio = Math.min(window.devicePixelRatio || 1, 2);
          const targetWidth = Math.round(canvasWidth * pixelRatio);
          const targetHeight = Math.round(canvasHeight * pixelRatio);
          if (canvas.width !== targetWidth || canvas.height !== targetHeight) {
            canvas.width = targetWidth;
            canvas.height = targetHeight;
          }
          context.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        }

      };

      const placeNodes = () => {
        if (nodes.length === 0) {
          nodeCoordinates = [];
          return;
        }

        section.classList.add('is-orbit-ready');
        nodeCoordinates = nodes.map((node, index) => {
          const baseAngle = -Math.PI / 2 + (tau * index) / nodes.length;
          const angle = baseAngle + orbitAngle;
          const x = Math.cos(angle) * radiusX;
          const y = Math.sin(angle) * radiusY;
          const depth = (Math.sin(angle) + 1) / 2;
          const verticalPosition = Math.abs(Math.sin(angle));
          const scale = desktopOrbit
            ? 0.91 + depth * 0.11
            : 0.9 + verticalPosition * 0.04 + depth * 0.02;
          const opacity = 0.67 + depth * 0.33;
          node.style.setProperty('--orbit-x', `${x.toFixed(2)}px`);
          node.style.setProperty('--orbit-y', `${y.toFixed(2)}px`);
          node.style.setProperty('--orbit-scale', scale.toFixed(3));
          node.style.setProperty('--orbit-opacity', opacity.toFixed(3));
          node.style.setProperty('--orbit-z', String(Math.round(3 + depth * 5)));
          node.style.setProperty('--orbit-depth', depth.toFixed(3));
          node.style.setProperty('--orbit-node-glow', (0.22 + depth * 0.44).toFixed(3));
          return {
            x: canvasOffsetX + stageWidth / 2 + x,
            y: canvasOffsetY + stageHeight / 2 + y,
            depth
          };
        });
      };

      const drawScene = (time) => {
        if (!context || !canvas) return;
        context.clearRect(0, 0, canvasWidth, canvasHeight);
        const styles = getComputedStyle(section);
        const accent = styles.getPropertyValue('--fc-accent').trim() || '#c8a969';
        const textColor = styles.getPropertyValue('--fc-text').trim() || '#f3eee4';
        const centerX = canvasOffsetX + stageWidth / 2;
        const centerY = canvasOffsetY + stageHeight / 2;
        const glowX = centerX + pointerX * stageWidth * 0.34;
        const glowY = centerY + pointerY * stageHeight * 0.3;
        const glow = context.createRadialGradient(glowX, glowY, 0, glowX, glowY, Math.max(stageWidth, stageHeight) * 0.48);
        glow.addColorStop(0, `${accent}20`);
        glow.addColorStop(0.34, `${accent}08`);
        glow.addColorStop(1, `${accent}00`);
        context.fillStyle = glow;
        context.fillRect(0, 0, canvasWidth, canvasHeight);

        stars.forEach((star) => {
          const x = ((star.x + time * star.drift + 1) % 1) * canvasWidth;
          const y = star.y * canvasHeight;
          const twinkle = 0.22 + (Math.sin(time * 0.001 * star.pulse + star.phase) + 1) * 0.27;
          context.beginPath();
          context.fillStyle = star.size > 1.15 ? accent : textColor;
          context.globalAlpha = twinkle;
          context.arc(x, y, star.size, 0, tau);
          context.fill();
        });
        context.globalAlpha = 1;

        context.save();
        context.strokeStyle = accent;
        context.lineWidth = 1;
        context.setLineDash([2, 11]);
        context.globalAlpha = 0.17;
        nodeCoordinates.forEach((point, index) => {
          context.beginPath();
          context.moveTo(centerX, centerY);
          context.lineTo(point.x, point.y);
          context.stroke();

          if (index === activeIndex) {
            context.save();
            context.setLineDash([]);
            context.globalAlpha = 0.8;
            context.lineWidth = 1.4;
            context.shadowColor = accent;
            context.shadowBlur = 16;
            context.beginPath();
            context.moveTo(centerX, centerY);
            context.lineTo(point.x, point.y);
            context.stroke();
            context.restore();
          }
        });
        context.restore();

        context.save();
        context.strokeStyle = accent;
        context.lineWidth = 1;
        context.globalAlpha = 0.21;
        context.beginPath();
        context.ellipse(centerX, centerY, radiusX, radiusY, 0, 0, tau);
        context.stroke();
        context.globalAlpha = 0.09;
        context.beginPath();
        context.ellipse(centerX, centerY, radiusX * 0.76, radiusY * 0.76, -0.12, 0, tau);
        context.stroke();
        context.restore();

        for (let index = 0; index < 12; index += 1) {
          const satelliteAngle = orbitAngle * (index % 2 === 0 ? 1.7 : -1.12) + (tau * index) / 12;
          const satelliteRadius = index % 3 === 0 ? 0.76 : 1;
          const x = centerX + Math.cos(satelliteAngle) * radiusX * satelliteRadius;
          const y = centerY + Math.sin(satelliteAngle) * radiusY * satelliteRadius;
          const size = index % 3 === 0 ? 2.2 : 1.15;
          context.save();
          context.fillStyle = accent;
          context.globalAlpha = 0.48 + (Math.sin(time * 0.002 + index) + 1) * 0.2;
          context.shadowColor = accent;
          context.shadowBlur = index % 3 === 0 ? 17 : 8;
          context.beginPath();
          context.arc(x, y, size, 0, tau);
          context.fill();
          context.restore();
        }

        const cometPhase = (time % 9200) / 9200;
        const cometAngle = cometPhase * tau * 1.18 - Math.PI * 0.7;
        const cometX = centerX + Math.cos(cometAngle) * radiusX * 1.08;
        const cometY = centerY + Math.sin(cometAngle) * radiusY * 1.08;
        const tailX = centerX + Math.cos(cometAngle - 0.13) * radiusX * 1.08;
        const tailY = centerY + Math.sin(cometAngle - 0.13) * radiusY * 1.08;
        const cometGradient = context.createLinearGradient(tailX, tailY, cometX, cometY);
        cometGradient.addColorStop(0, `${accent}00`);
        cometGradient.addColorStop(1, accent);
        context.save();
        context.strokeStyle = cometGradient;
        context.lineWidth = 1.5;
        context.globalAlpha = Math.sin(cometPhase * Math.PI) * 0.8;
        context.shadowColor = accent;
        context.shadowBlur = 12;
        context.beginPath();
        context.moveTo(tailX, tailY);
        context.lineTo(cometX, cometY);
        context.stroke();
        context.restore();
        context.globalAlpha = 1;
      };

      const setPaused = (paused) => {
        userPaused = paused;
        section.classList.toggle('is-motion-paused', paused);
        if (motionToggle) {
          motionToggle.setAttribute('aria-pressed', String(paused));
          motionToggle.setAttribute('aria-label', paused ? pausedMotionLabel : activeMotionLabel);
        }
        if (motionLabel) motionLabel.textContent = paused ? pausedMotionLabel : activeMotionLabel;
      };

      const wake = (link, index) => {
        interactionPaused = true;
        activeIndex = index;
        links.forEach((item) => item.classList.toggle('is-active', item === link));
        if (core) core.classList.add('is-awake');
        section.classList.add('is-path-active');
        if (status) status.textContent = link.dataset.flaireDestination;
      };

      const rest = () => {
        interactionPaused = false;
        activeIndex = -1;
        links.forEach((item) => item.classList.remove('is-active'));
        if (core) core.classList.remove('is-awake');
        section.classList.remove('is-path-active');
        if (status) status.textContent = initialStatus;
      };

      links.forEach((link, index) => {
        link.addEventListener('pointerenter', () => wake(link, index));
        link.addEventListener('focus', () => wake(link, index));
        link.addEventListener('pointerleave', rest);
        link.addEventListener('blur', rest);
      });

      if (motionToggle) motionToggle.addEventListener('click', () => setPaused(!userPaused));

      if (stage) {
        stage.addEventListener('pointermove', (event) => {
          const bounds = stage.getBoundingClientRect();
          const x = (event.clientX - bounds.left) / bounds.width;
          const y = (event.clientY - bounds.top) / bounds.height;
          pointerTargetX = Math.max(-1, Math.min(1, x * 2 - 1));
          pointerTargetY = Math.max(-1, Math.min(1, y * 2 - 1));
          section.style.setProperty('--pointer-x', `${(x * 100).toFixed(2)}%`);
          section.style.setProperty('--pointer-y', `${(y * 100).toFixed(2)}%`);
          if (core) {
            const shiftScale = desktopOrbit ? 1 : 0.55;
            core.style.setProperty('--core-shift-x', `${(pointerTargetX * 8 * shiftScale).toFixed(2)}px`);
            core.style.setProperty('--core-shift-y', `${(pointerTargetY * 6 * shiftScale).toFixed(2)}px`);
            core.style.setProperty('--core-tilt-x', `${(pointerTargetX * 2.2 * shiftScale).toFixed(2)}deg`);
            core.style.setProperty('--core-tilt-y', `${(-pointerTargetY * 2.2 * shiftScale).toFixed(2)}deg`);
          }
        });

        stage.addEventListener('pointerleave', () => {
          pointerTargetX = 0;
          pointerTargetY = 0;
          if (core) {
            core.style.setProperty('--core-shift-x', '0px');
            core.style.setProperty('--core-shift-y', '0px');
            core.style.setProperty('--core-tilt-x', '0deg');
            core.style.setProperty('--core-tilt-y', '0deg');
          }
        });
      }

      const animate = (time) => {
        if (!document.documentElement.contains(section)) return;
        const delta = Math.min(0.05, Math.max(0, (time - previousTime) / 1000));
        previousTime = time;
        pointerX += (pointerTargetX - pointerX) * 0.065;
        pointerY += (pointerTargetY - pointerY) * 0.065;

        if (visible && motionEnabled && !userPaused && !interactionPaused) {
          const speedInfluence = 1 + pointerX * 0.16;
          orbitAngle = (orbitAngle + (tau / orbitDuration) * delta * speedInfluence) % tau;
        }

        if (visible) {
          placeNodes();
          drawScene(time);
        }

        frameId = window.requestAnimationFrame(animate);
      };

      if ('ResizeObserver' in window && stage) {
        const resizeObserver = new ResizeObserver(measure);
        resizeObserver.observe(stage);
      } else {
        window.addEventListener('resize', measure, { passive: true });
      }

      if ('IntersectionObserver' in window) {
        const intersectionObserver = new IntersectionObserver((entries) => {
          visible = entries[0] ? entries[0].isIntersecting : true;
          if (visible) previousTime = performance.now();
        }, { rootMargin: '260px 0px' });
        intersectionObserver.observe(section);
      }

      measure();
      setPaused(!motionEnabled);
      frameId = window.requestAnimationFrame(animate);
      section.addEventListener('shopify:block:select', () => setPaused(true));
      section.addEventListener('shopify:block:deselect', () => setPaused(false));
    });
  };

  initializeFlaireCelestial(document);
  document.addEventListener('shopify:section:load', (event) => initializeFlaireCelestial(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
